import { styled } from '@moonpig/launchpad-utils'
import { IllustrationBubbleError } from '@moonpig/launchpad-assets'
import { Container } from '@moonpig/launchpad-components'

export const StyledContainer = styled(Container)`
  margin-top: 120px;
`

export const StyledIllustration = styled(IllustrationBubbleError)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 218px;
`
